import React from 'react'
import  datas  from "./../MenuCategory"
import { Link } from "react-router-dom"


function AllRestaurants({ id1 }) {
  return (
    <div>
            <div className="filters shadow-sm rounded menu-categories-main bg-white mb-4">
              <div className="filters-body">
                <div id="accordion">
                  <div className="filters-card border-bottom p-4">
                    <div className="filters-card-header menu-category-menu-page-main" id="headingOne">
                      <h6 className="mb-0">
                        <a href="#" className="btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          Menu Categories<i className="icofont-arrow-down float-right" />
                        </a>
                      </h6>
                    </div>

                    <div id="collapseOne" className="collapse show menu-category-menu-page-main" aria-labelledby="headingOne" data-parent="#accordion">
                    {datas.map((data, index) => {

return(
  <Link to={`/category/${data.id}`} className="filters-card-body card-shop-filters">
    <ul>
    {id1 !== data.name &&(
     <li>
           <hr />
     <label className="text-black-50" htmlFor="cb1">
      <center style={{fontWeight:'bold'}}>{data.name}</center>
    </label>
     </li>
            )}
    </ul>

</Link>
)
})}
                    </div>





                  <div className="filters-card border-bottom p-4 menu-category-menu-page-mobile">
                    <div className="filters-card-header" id="headingOffer">
                      <h6 className="mb-0">
                        <a href="#" className="btn-link" data-toggle="collapse" data-target="#collapseOffer" aria-expanded="true" aria-controls="collapseOffer">
                        Menu Categories<i className="icofont-arrow-down float-right" />
                        </a>
                      </h6>
                    </div>
                    <div id="collapseOffer" className="collapse" aria-labelledby="headingOffer" data-parent="#accordion">
                    {datas.map((data, index) => {

return(
  <Link to={`/category/${data.id}`} className="filters-card-body card-shop-filters">
    <ul>
    {id1 !== data.name &&(
     <li>
           <hr />
     <label className="text-black-50" htmlFor="cb1">
      <center style={{fontWeight:'bold'}}>{data.name}</center>
    </label>
     </li>
            )}
    </ul>

</Link>
)
})}
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
    </div>
  )
}

export default AllRestaurants